export default __webpack_public_path__ + "static/media/virtuale.7c33515f.jpg";